// https://www.w3.org/TR/html51/syntax.html#writing-html-documents-elements
const VOID_ELEMENTS: { [tagName: string]: boolean } = {
  area: true,
  base: true,
  br: true,
  col: true,
  command: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
};

const TAG_NAME_REPLACEMENTS: { [name: string]: string } = {
  'h3-tab-group': 'mat-tab-group',
  'h3-tab': 'mat-tab',
};

const ATTTRIBUTE_REPLACEMENTS: { [name: string]: string } = {
  'h3-show-only-when': '*ngIf',
};

export function transformLayout(layout: string) {
  const transformed: string[] = [];
  const layoutDocument = new DOMParser().parseFromString(layout, 'text/html');
  transformChildren(layoutDocument.body, transformed);
  return transformed.join('');
}

function transformChildren(el: Element, transformed: string[]) {
  for (let i = 0; i < el.childNodes.length; ++i) {
    const child = el.childNodes.item(i);
    switch (child.nodeType) {
      case 1: // element
        transformElement(child as Element, transformed);
        break;
      case 3: // text node
        if (child.textContent) {
          transformed.push(child.textContent);
        }
        break;
    }
  }
}

function transformElement(el: Element, transformed: string[]) {
  const tagName = convertH3Element(el);
  transformed.push('<');
  transformed.push(tagName);
  transformAttributes(el, transformed);
  transformed.push('>');
  transformChildren(el, transformed);

  if (!VOID_ELEMENTS[tagName]) {
    transformed.push(`</${tagName}>`);
  }
}

function transformAttributes(el: Element, transformed: string[]) {
  $.each(el.attributes, (_i, attribute) => {
    const name = ATTTRIBUTE_REPLACEMENTS[attribute.name] || attribute.name;
    transformed.push(` ${name}="${attribute.value}"`);
  });

  appendExtraAttributes(el, transformed);
}

function appendH3ImageAttributes(el: Element, transformed: string[]) {
  const gridSize = el.getAttribute('grid-size');
  if (gridSize) {
    transformed.push(` [gridSize]="'${gridSize}'"`);
  }
  const gridColor = el.getAttribute('grid-color');
  if (gridColor) {
    transformed.push(` [gridColor]="'${gridColor}'"`);
  }
}

function appendExtraAttributes(el: Element, transformed: string[]) {
  if (el.tagName === 'H3-IMAGE') {
    appendH3ImageAttributes(el, transformed);
  }
}

function convertH3Element(el: Element) {
  switch (el.tagName) {
    case 'H3-OUTPUT':
      const hasDecorations = el.getAttribute('decoration') !== 'none';
      return hasDecorations ? 'h3-output' : 'h3-naked-output';
    default:
      return (
        TAG_NAME_REPLACEMENTS[el.tagName.toLowerCase()] ||
        el.tagName.toLowerCase()
      );
  }
}
